import styled from '@emotion/styled'

import { CommentCard as SharedCommentCard, CommentText } from '../../hey-nic/styled'
import breakpoints from '../../../guided-toolbox/utils/breakpoints'

// Desktop-only; tablet and below use the comment card instead (no room for a transcript + input).
export const HOME_CHAT_VIEWPORT = `(min-width: ${breakpoints.lgTablet + 1}px)`

/*
 * Design draws the panel 522 × 359 — the same height as the plan column beside
 * it (48px heading + 24 gap + ~222 donut + 24 gap + 41 CTA row). The story
 * anticipates needing more than that once it's in a real browser, and it's
 * right: at 359 the input, disclaimer and opening comment leave barely a bubble
 * of transcript. 420 keeps the panel visually paired with the plan column while
 * giving the conversation somewhere to go.
 */
const PANEL_HEIGHT = 420

// Matches the alerts box it replaces: 2px light-blue border, radius 10, no fill
// (the page's background gradient shows through).
export const HomeChatCard = styled.div`
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  width: 100%;
  height: ${PANEL_HEIGHT}px;
  border: 2px solid ${p => p.theme.primaryLighter ?? '#d4ebf2'};
  border-radius: 10px;
  overflow: hidden;
`

// The scrolling middle. Part of the unbroken min-height: 0 chain the transcript
// needs in order to shrink instead of pushing the input off the card.
export const HomeChatBody = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  flex: 1 1 auto;
  min-height: 0;
`

// Fixed bottom row: the input and the AI disclaimer. 20px gutters match the
// transcript's (CenterColumn in compact mode), so the input's edges line up with
// the message bubbles above it.
export const HomeChatFooter = styled.div`
  flex: 0 0 auto;
  padding: 0 20px 15px;
`

/*
 * Narrow-viewport entry point, under the plan. Same card as SBSA's, with the
 * design's darker text and a clamp: the comment is every active alert's body
 * copy joined together, which can run to a paragraph, and the chip is a teaser —
 * the full text is the chat's first message once it opens.
 */
export const HomeCommentCard = styled(SharedCommentCard)`
  color: ${p => p.theme.darkestGray ?? '#022a3a'};
`

export const HomeCommentText = styled(CommentText)`
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
`
